import React, { FC } from 'react'
import s from './AdvDetailedTooltip.module.sass'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { Tooltip } from '@shared/ui/Overlays/Tooltip'
import { Text } from '@shared/ui/Typography/Text'

interface Props {
  description: string
  token: string
  className?: string
}

const AdvDetailedTooltip: FC<Props> = ({ description, token, className = '' }) => {
  return (
    <ErrorBoundary>
      <Tooltip.Content className={s.content}>
        <Text sizes={'S'}>
          {description}
          <br />
          Токен: {token}
        </Text>
      </Tooltip.Content>
    </ErrorBoundary>
  )
}

export default AdvDetailedTooltip
